const API_KEY = 'AIzaSyDTAIxHyYlPm7fouuONS728V7q7u-vi2Xk';
export default API_KEY;